import type { SelectedModuleSlice, SelectedModuleState, ViewerSliceCreator } from "./types";

export const selectedModuleInitialState: SelectedModuleState = {
  selectedModuleInstanceId: null,
  selectedModuleName: null,
  selectedModulePosition: null,
  selectedModuleLeafLinks: [],
  selectedModuleRootLink: null,
  selectedModuleCanBeChild: true,
  selectedModuleHasServo: true,
  selectedModuleParentId: null,
  selectedModuleParentLink: null,
  selectedModuleChildLink: null,
  availableConnections: [],
  selectedModulePrefix: null,
};

export const createSelectedModuleSlice: ViewerSliceCreator<SelectedModuleSlice> = (set) => ({
  ...selectedModuleInitialState,

  setSelectedModule: (msg) =>
    set((state) => {
      state.selectedModuleInstanceId = msg.instance_id ?? null;
      state.selectedModuleName = msg.module_name ?? null;
      state.selectedModulePosition = msg.position ?? null;
      state.selectedModuleLeafLinks = msg.leaf_links || [];
      state.selectedModuleRootLink = msg.root_link ?? null;
      // Default to true for backward compatibility
      state.selectedModuleCanBeChild = msg.can_be_child ?? true;
      state.selectedModuleHasServo = msg.has_servo ?? true;
      // Explicitly convert undefined to null (backend omits None values from JSON)
      state.selectedModuleParentId = msg.parent_instance_id ?? null;
      state.selectedModuleParentLink = msg.parent_link_name ?? null;
      state.selectedModuleChildLink = msg.child_link_name ?? null;
      state.availableConnections = msg.available_connections || [];
      state.selectedModulePrefix = msg.prefix ?? null;
    }),
});
